import { useApi } from 'api'

export const useUpdateClient = () => {
  const apiClient = useApi().apiClient

  return apiClient.useMutation('updateClientEvent')
}
